const RequiredLabel = ({ text }) => (
    <>
        {text} <span style={{ color: "red" }}>*</span>
    </>
);
export default RequiredLabel;